<template>
  <CRow>
    <CCol sm="12" md="6" v-if="showBar">
      <CCard>
        <CCardHeader> {{ headerTitle}} </CCardHeader>
        <CCardBody>
          <CChartBar :datasets="barChartDataset" :labels="barChartLabels" :options="{
            responsive: true,
            scales: {
              xAxes: [
                {
                  ticks: {
                    maxRotation: 12,
                    minRotation: 1,
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    stepSize: 1,
                  },
                },
              ],
            },
          }" />
        </CCardBody>
      </CCard>
    </CCol>
  
    <CCol sm="12" md="6" v-if="showPie">
      <CCard>
        <CCardHeader> {{ secondHeaderTitle }} </CCardHeader>
        <CCardBody>
          <CChartPie :datasets="pieChartDatasets" :labels="['النشطه', 'المتوقفه']" />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { CChartBar, CChartPie } from "@coreui/vue-chartjs";
export default {
  name: "StatChartComponent",
  components: {
    CChartBar,
    CChartPie
  },
  props: ["headerTitle", "secondHeaderTitle", "barData", "pieData", "entity"],
  data() {
    return {
      statistics: null,
      showBar: false,
      showPie: false,
      barChartLabels: [],
      barChartDataset: [
        {
          label: "",
          data: [],
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(255, 159, 64, 0.2)",
            "rgba(255, 205, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(201, 203, 207, 0.2)",
          ],
          borderColor: [
            "rgb(255, 99, 132)",
            "rgb(255, 159, 64)",
            "rgb(255, 205, 86)",
            "rgb(75, 192, 192)",
            "rgb(54, 162, 235)",
            "rgb(153, 102, 255)",
            "rgb(201, 203, 207)",
          ],
          borderWidth: 1,
        },
      ],
      pieChartDatasets: [
        {
          backgroundColor: ["#41B883", "#E46651"],
          data: [],
        },
      ],
    };
  },
  created() {
    this.handleBarChartData(this.barData);
    this.handlePieChartData(this.pieData);
  },
  methods: {
    handleBarChartData(data) {
      data.forEach((element) => {
        this.barChartLabels.push(element.month);
        this.barChartDataset[0].data.push(element[this.entity]);
      });
      this.showBar = true;
    },
    handlePieChartData(data) {
      this.pieChartDatasets[0].data.push(data[0].active);
      this.pieChartDatasets[0].data.push(data[0].stopped);
      this.showPie = true;
    },
  }
};
</script>
